const Eyeopen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_2056_26496)">
        <path
          d="M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z"
          fill="#7E7E7E"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2056_26496">
          <rect width="24" height="24" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  );
};

const Eyeclose = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none"
    >
      <path
        d="M9.99999 13.0001C7.62968 13.0001 5.71093 11.1654 5.53437 8.84039L2.25624 6.30696C1.82531 6.84758 1.42874 7.41914 1.10874 8.04414C1.03726 8.18555 1.00001 8.34179 1.00001 8.50024C1.00001 8.65869 1.03726 8.81492 1.10874 8.95633C2.80343 12.2629 6.15843 14.5001 9.99999 14.5001C10.8409 14.5001 11.6522 14.3751 12.4341 14.1732L10.8125 12.9185C10.5447 12.9703 10.2727 12.9976 9.99999 13.0001ZM19.8069 14.8157L16.3522 12.1457C17.4016 11.2613 18.2647 10.177 18.8912 8.95602C18.9627 8.81461 19 8.65838 19 8.49993C19 8.34147 18.9627 8.18524 18.8912 8.04383C17.1966 4.73727 13.8416 2.50008 9.99999 2.50008C8.39109 2.50203 6.80831 2.90707 5.39624 3.67821L1.42062 0.605395C1.36878 0.565053 1.30949 0.535323 1.24615 0.517902C1.18282 0.500482 1.11667 0.495713 1.05149 0.503868C0.986304 0.512023 0.923369 0.532942 0.866275 0.56543C0.809182 0.597917 0.75905 0.641337 0.718743 0.693207L0.105306 1.48289C0.0239305 1.58758 -0.0125333 1.7203 0.0039342 1.85186C0.0204017 1.98342 0.088452 2.10306 0.193118 2.18446L18.5794 16.3948C18.6312 16.4351 18.6905 16.4648 18.7538 16.4823C18.8172 16.4997 18.8833 16.5045 18.9485 16.4963C19.0137 16.4881 19.0766 16.4672 19.1337 16.4347C19.1908 16.4022 19.2409 16.3588 19.2812 16.307L19.895 15.5173C19.9763 15.4125 20.0127 15.2798 19.9962 15.1482C19.9797 15.0167 19.9116 14.8971 19.8069 14.8157ZM14.0656 10.3782L12.8375 9.42883C12.9409 9.12992 12.9958 8.81636 13 8.50008C13.0061 8.03704 12.9035 7.57902 12.7005 7.16281C12.4975 6.74661 12.1996 6.38382 11.831 6.10359C11.4623 5.82336 11.0331 5.63349 10.5777 5.54925C10.1223 5.46501 9.65358 5.48873 9.20906 5.61852C9.3975 5.87386 9.49943 6.18273 9.49999 6.50008C9.49533 6.60569 9.47919 6.71047 9.45187 6.81258L7.15156 5.03477C7.95061 4.36702 8.95866 4.00085 9.99999 4.00008C10.591 3.99975 11.1763 4.11592 11.7225 4.34195C12.2686 4.56798 12.7648 4.89944 13.1827 5.31737C13.6006 5.7353 13.9321 6.2315 14.1581 6.77762C14.3841 7.32373 14.5003 7.90904 14.5 8.50008C14.5 9.17602 14.3347 9.80602 14.0656 10.3785V10.3782Z"
        fill="#828282"
      />
    </svg>
  );
};

const Dashboardsvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 10.8334H8.33333V3.33337H3.33333V10.8334ZM3.33333 16.6667H8.33333V12.5H3.33333V16.6667ZM11.6667 16.6667H16.6667V9.16671H11.6667V16.6667ZM11.6667 3.33337V7.50004H16.6667V3.33337H11.6667Z"
        stroke="#832D49"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};




const Userssvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M13 9.5C13 11.433 11.433 13 9.5 13C7.567 13 6 11.433 6 9.5C6 7.567 7.567 6 9.5 6C11.433 6 13 7.567 13 9.5Z"
        fill="#323232"
      />
      <path
        d="M15.6309 7.15517C15.9015 7.05482 16.1943 7 16.4999 7C17.8806 7 18.9999 8.11929 18.9999 9.5C18.9999 10.8807 17.8806 12 16.4999 12C16.1943 12 15.9015 11.9452 15.6309 11.8448"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M3 19C3.69137 16.6928 5.46998 16 9.5 16C13.53 16 15.3086 16.6928 16 19"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M17 15C19.403 15.095 20.5292 15.6383 21 17"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <path
        d="M13 9.5C13 11.433 11.433 13 9.5 13C7.567 13 6 11.433 6 9.5C6 7.567 7.567 6 9.5 6C11.433 6 13 7.567 13 9.5Z"
        stroke="#323232"
        strokeWidth={2}
      />
    </svg>
  );
};

const QuickMessagesvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);


const Enquirysvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.1"
        d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14C20 15.1046 19.1046 16 18 16H9L5 19.5V16H6C4.89543 16 4 15.1046 4 14V6Z"
        fill="#323232"
      />
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V14C20 15.1046 19.1046 16 18 16H9L5 19.5V16H6C4.89543 16 4 15.1046 4 14V6Z"
        stroke="#323232"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M10.5 9.5C10.5 8.5 11.2 8 12 8C12.8 8 13.5 8.5 13.5 9.3C13.5 10 13 10.3 12.4 10.7C12 11 12 11.3 12 11.7"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="13.5" r="0.9" fill="#323232" />
    </svg>
  );
};


const Templatesvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="8" y1="13" x2="16" y2="13" />
    <line x1="8" y1="17" x2="14" y2="17" />
  </svg>
);

const Adminsvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const Watersvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12c1.5-2 3.5-2 5 0s3.5 2 5 0 3.5-2 5 0 3.5 2 5 0" />
    <path d="M2 18c1.5-2 3.5-2 5 0s3.5 2 5 0 3.5-2 5 0 3.5 2 5 0" />
    <path d="M2 6c1.5-2 3.5-2 5 0s3.5 2 5 0 3.5-2 5 0 3.5 2 5 0" />
  </svg>
);

const Catchsvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 12s-3-6-9-6-9 6-9 6 3 6 9 6 9-6 9-6Z" />
    <path d="M2 12s3-6 9-6 9 6 9 6" />
    <circle cx="16" cy="11" r="0.5" fill="currentColor" />
  </svg>
);

const Rulessvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    <path d="M8 7h8" />
    <path d="M8 11h6" />
  </svg>
);
const Trophy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="1.8"
    stroke-linecap="round" stroke-linejoin="round">
    <path d="M8 21h8" />
    <path d="M12 17v4" />
    <path d="M7 4h10v5a5 5 0 0 1-10 0V4z" />
    <path d="M7 6H5a2 2 0 0 0 2 4" />
    <path d="M17 6h2a2 2 0 0 1-2 4" />
  </svg>
);

const Archivesvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="5" rx="1" />
    <path d="M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9" />
    <line x1="10" y1="14" x2="14" y2="14" />
  </svg>
);

const Newslettersvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2" />
    <path d="M18 14h-8" />
    <path d="M15 18h-5" />
    <path d="M10 6h8v4h-8V6Z" />
  </svg>
);
const Mapsvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
    <line x1="9" y1="3" x2="9" y2="18" />
    <line x1="15" y1="6" x2="15" y2="21" />
  </svg>
);

const Incidentsvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

const Vehiclesvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 17h14M5 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm14 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0ZM5 17V9l2-5h10l2 5v8" />
    <path d="M3 12h18" />
  </svg>
);
const Fishsvg = () => (

  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.41667 10C6.20001 7.11667 9.53334 5 12.5 5C15.4667 5 17.55 7.11667 18.3333 10C17.55 12.8917 15.4667 15 12.5 15C9.53334 15 6.20001 12.8917 5.41667 10Z" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15 10V10.4167" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.3333 14.9417C12.2493 13.5223 11.6621 11.786 11.6621 10C11.6621 8.21408 12.2493 6.47769 13.3333 5.05835" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.83333 8.89171C5.83333 6.66671 4.64999 4.97504 2.27499 4.58337C1.44166 5.83337 1.44166 8.75004 2.46666 10C1.43333 11.25 1.43333 14.1667 2.27499 15.4167C4.64999 15.025 5.83333 13.3334 5.83333 11.1084" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.71667 6.05001C8.50001 4.90001 7.64167 3.53334 6.66667 2.50001H11.5C11.8954 2.49855 12.2785 2.63771 12.5807 2.89265C12.883 3.14759 13.0848 3.50168 13.15 3.89168L13.3417 5.05835" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M13.3417 14.9417L13.15 16.1083C13.0848 16.4983 12.883 16.8524 12.5807 17.1074C12.2785 17.3623 11.8954 17.5015 11.5 17.5H7.91667C8.72405 16.5846 9.16606 15.4039 9.15834 14.1833" stroke="#832D49" stroke-width="1.83333" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

);

const FishsvgGreen = () => (

  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.4165 10C6.19984 7.11667 9.53317 5 12.4998 5C15.4665 5 17.5498 7.11667 18.3332 10C17.5498 12.8917 15.4665 15 12.4998 15C9.53317 15 6.19984 12.8917 5.4165 10Z"
      stroke="#298E6D" stroke-width="1.66667"
      stroke-linecap="round" stroke-linejoin="round" />
    <path d="M15 10V10.4167" stroke="#298E6D" stroke-width="1.66667"
      stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M13.3333 14.9417C12.2493 13.5223 11.6621 11.786 11.6621 10C11.6621 8.21408 12.2493 6.47769 13.3333 5.05835"
      stroke="#298E6D" stroke-width="1.66667"
      stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M5.83348 8.89171C5.83348 6.66671 4.65015 4.97504 2.27515 4.58337C1.44181 5.83337 1.44181 8.75004 2.46681 10C1.43348 11.25 1.43348 14.1667 2.27515 15.4167C4.65015 15.025 5.83348 13.3334 5.83348 11.1084"
      stroke="#298E6D" stroke-width="1.66667"
      stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M8.7165 6.05001C8.49984 4.90001 7.6415 3.53334 6.6665 2.50001H11.4998C11.8952 2.49855 12.2783 2.63771 12.5806 2.89265C12.8828 3.14759 13.0846 3.50168 13.1498 3.89168L13.3415 5.05834"
      stroke="#298E6D" stroke-width="1.66667"
      stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M13.3415 14.9417L13.1498 16.1083C13.0846 16.4983 12.8828 16.8524 12.5806 17.1074C12.2783 17.3623 11.8952 17.5015 11.4998 17.5H7.9165C8.72388 16.5846 9.16589 15.4039 9.15817 14.1833"
      stroke="#298E6D" stroke-width="1.66667"
      stroke-linecap="round" stroke-linejoin="round" />
  </svg>

);

const ZeroIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1234_493)">
      <path
        d="M9.99984 18.3333C14.6022 18.3333 18.3332 14.6023 18.3332 9.99996C18.3332 5.39759 14.6022 1.66663 9.99984 1.66663C5.39746 1.66663 1.6665 5.39759 1.6665 9.99996C1.6665 14.6023 5.39746 18.3333 9.99984 18.3333Z"
        stroke="#0D59A5" stroke-width="1.66667"
        stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12.5 7.5L7.5 12.5" stroke="#0D59A5"
        stroke-width="1.66667" stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M7.5 7.5L12.5 12.5" stroke="#0D59A5"
        stroke-width="1.66667" stroke-linecap="round"
        stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1234_493">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const MemberIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.5 14s-.5 0-.5-.5C3 12.5 3.5 10 6.5 9c-.6.6-1.5 1.9-1.5 3.5 0 .6.2 1.1.4 1.5H3.5ZM6 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
  </svg>
);

const EnquiryIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.5 14s-.5 0-.5-.5C3 12.5 3.5 10 6.5 9c-.6.6-1.5 1.9-1.5 3.5 0 .6.2 1.1.4 1.5H3.5ZM6 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
  </svg>
);
const NewEnquiryIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.5 14s-.5 0-.5-.5C3 12.5 3.5 10 6.5 9c-.6.6-1.5 1.9-1.5 3.5 0 .6.2 1.1.4 1.5H3.5ZM6 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
  </svg>
);
const CurrentMemberIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.5 14s-.5 0-.5-.5C3 12.5 3.5 10 6.5 9c-.6.6-1.5 1.9-1.5 3.5 0 .6.2 1.1.4 1.5H3.5ZM6 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
  </svg>
);
const LockedMemberIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.5 14s-.5 0-.5-.5C3 12.5 3.5 10 6.5 9c-.6.6-1.5 1.9-1.5 3.5 0 .6.2 1.1.4 1.5H3.5ZM6 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
  </svg>
);
const UnLockedMemberIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M11 1a3 3 0 0 0-3 3v4H2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2H9V4a2 2 0 1 1 4 0v2.5a.5.5 0 0 0 1 0V4a3 3 0 0 0-3-3Z" />
  </svg>
);
const HonoraryMemberIcon = () => (
  <svg width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8 0 6.29 2.6l-3.06.13 1.19 2.84L2.5 8l1.92 2.43-1.19 2.84 3.06.13L8 16l1.71-2.6 3.06-.13-1.19-2.84L13.5 8l-1.92-2.43 1.19-2.84-3.06-.13L8 0Zm0 3.24 1 1.51 1.78.08-.69 1.65 1.12 1.42-1.12 1.42.69 1.65-1.78.08L8 12.76l-1-1.51-1.78-.08.69-1.65L4.79 8l1.12-1.42-.69-1.65 1.78-.08L8 3.24Z" />
  </svg>
);

const IconEdit = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" className="me-2">
    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10ZM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5Zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5ZM4.147 12.646l-1.528 3.821 3.821-1.528.106-.106a.5.5 0 0 1-.468-.325.5.5 0 0 1-.325-.468.5.5 0 0 1-.325-.325.5.5 0 0 1-.325-.325l-.106.106Z" />
  </svg>
);

const IconReset = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" className="me-2">
    <path d="M8 1a4 4 0 0 0-4 4v2H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V5a4 4 0 0 0-4-4Zm0 1.5A2.5 2.5 0 0 1 10.5 5v2h-5V5A2.5 2.5 0 0 1 8 2.5ZM8 10a1 1 0 0 1 1 1v.5a1 1 0 1 1-2 0V11a1 1 0 0 1 1-1Z" />
  </svg>
);

const IconLock = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" className="me-2">
    <path d="M8 1a3 3 0 0 0-3 3v3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-3-3Zm0 1.5A1.5 1.5 0 0 1 9.5 4v3h-3V4A1.5 1.5 0 0 1 8 2.5Z" />
  </svg>
);

const IconUnlock = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" className="me-2">
    <path d="M11 1a3 3 0 0 0-3 3v3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9V4a1.5 1.5 0 0 1 3 0v2a.75.75 0 0 0 1.5 0V4a3 3 0 0 0-3-3Z" />
  </svg>
);

const IconTrash = ({ className = "" }) => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="currentColor" className={`me-2 ${className}`}>
    <path d="M5.5 5.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
  </svg>
);

const IconDots = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" />
  </svg>
);

const IconUserPlaceholder = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <circle cx="20" cy="20" r="20" fill="#f0d7e0" />
    <circle cx="20" cy="16" r="6.5" fill="#a6234c" fillOpacity="0.55" />
    <path d="M8 33c1.6-6.2 7-9.5 12-9.5s10.4 3.3 12 9.5" stroke="#a6234c" strokeOpacity="0.55" strokeWidth="3.2" strokeLinecap="round" />
  </svg>
);

const IconEmpty = () => (
  <svg width="90" height="90" viewBox="0 0 24 24" fill="none">
    <rect x="2" y="4" width="20" height="16" rx="2" stroke="#d9b8c6" strokeWidth="1.5" />
    <path d="M2 9h20" stroke="#d9b8c6" strokeWidth="1.5" />
    <circle cx="8" cy="14.5" r="1.4" fill="#e8c7d4" />
    <path d="M12 14h7" stroke="#e8c7d4" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 17h5" stroke="#e8c7d4" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 16 16" fill="currentColor">
    <path d="M4.146 4.146a.5.5 0 0 1 .708 0L8 7.293l3.146-3.147a.5.5 0 1 1 .708.708L8.707 8l3.147 3.146a.5.5 0 0 1-.708.708L8 8.707l-3.146 3.147a.5.5 0 0 1-.708-.708L7.293 8 4.146 4.854a.5.5 0 0 1 0-.708Z" />
  </svg>
);
const HelpOutlineIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
    <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16Z" />
    <path d="M5.25 6.033h1.32c.037-.66.372-1.166 1.024-1.166.632 0 .972.457.972.982 0 .467-.15.673-.6.977l-.325.226c-.487.328-.686.658-.686 1.348v.209h1.36v-.16c0-.51.169-.717.61-1.024l.336-.234c.487-.34.833-.774.833-1.446 0-1.14-.909-1.827-2.181-1.827-1.406 0-2.148.828-2.192 1.887Zm1.617 5.795c.505 0 .861-.343.861-.813 0-.474-.356-.812-.861-.812-.5 0-.861.338-.861.812 0 .47.356.813.861.813Z" />
  </svg>
);
const VisibilityIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8ZM8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z" />
    <path d="M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
  </svg>
);
const VisibilityOffIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="currentColor">
    <path d="M13.359 11.238C14.6 10.05 15.5 8.6 16 8c-.5-.6-1.4-2.05-2.641-3.238C11.985 3.44 10.194 2.5 8 2.5c-.784 0-1.503.12-2.155.322l1.11 1.11A4.98 4.98 0 0 1 8 3.5c1.657 0 3 1.343 3 3 0 .396-.077.774-.216 1.121l1.093 1.093a5.02 5.02 0 0 0 1.482-1.976ZM11 8c0 .396-.077.774-.216 1.121l1.5 1.5A2.98 2.98 0 0 0 11 8ZM6.32 6.32 4.68 4.68A9.02 9.02 0 0 0 2.641 6.762C1.4 7.95.5 9.4 0 10c.5.6 1.4 2.05 2.641 3.238C4.015 14.56 5.806 15.5 8 15.5c1.297 0 2.416-.32 3.36-.85l-1.618-1.618A5 5 0 0 1 8 13.5c-1.657 0-3-1.343-3-3 0-.463.104-.9.29-1.291L6.32 6.32ZM3.706 3.293l9 9-.706.707-9-9 .706-.707Z" />
  </svg>
);

const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const CarIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1080_1042)">
      <path
        d="M19.1583 3.9335C18.8355 3.05003 18.2492 2.28698 17.4787 1.74746C16.7082 1.20795 15.7906 0.91798 14.85 0.916748H7.15001C6.20939 0.91798 5.29183 1.20795 4.52133 1.74746C3.75083 2.28698 3.16453 3.05003 2.84167 3.9335L0.366671 10.7416C0.12325 11.4121 -0.000847671 12.1201 4.35771e-06 12.8334V13.7501C0.00163999 14.4585 0.168151 15.1568 0.486356 15.7897C0.80456 16.4226 1.26572 16.9727 1.83334 17.3966C1.83334 17.4039 1.83334 17.4094 1.83334 17.4167V19.2501C1.83334 19.9794 2.12307 20.6789 2.63879 21.1946C3.15452 21.7104 3.85399 22.0001 4.58334 22.0001C5.31268 22.0001 6.01216 21.7104 6.52788 21.1946C7.04361 20.6789 7.33334 19.9794 7.33334 19.2501V18.3334H14.6667V19.2501C14.6667 19.9794 14.9564 20.6789 15.4721 21.1946C15.9879 21.7104 16.6873 22.0001 17.4167 22.0001C18.146 22.0001 18.8455 21.7104 19.3612 21.1946C19.8769 20.6789 20.1667 19.9794 20.1667 19.2501V17.4167C20.1667 17.4094 20.1667 17.4039 20.1667 17.3966C20.7343 16.9727 21.1954 16.4226 21.5137 15.7897C21.8319 15.1568 21.9984 14.4585 22 13.7501V12.8334C22.0009 12.1204 21.8768 11.4127 21.6333 10.7425L19.1583 3.9335ZM4.56684 4.5605C4.76066 4.03082 5.1122 3.57329 5.57408 3.24958C6.03596 2.92587 6.58598 2.75154 7.15001 2.75008H14.85C15.4143 2.75116 15.9648 2.92532 16.427 3.24906C16.8893 3.57279 17.2411 4.03053 17.435 4.5605L19.4407 10.0834H2.55842L4.56684 4.5605ZM5.50001 19.2501C5.50001 19.4932 5.40343 19.7264 5.23152 19.8983C5.05961 20.0702 4.82645 20.1667 4.58334 20.1667C4.34022 20.1667 4.10707 20.0702 3.93516 19.8983C3.76325 19.7264 3.66667 19.4932 3.66667 19.2501V18.2417C3.96837 18.303 4.27548 18.3337 4.58334 18.3334H5.50001V19.2501ZM18.3333 19.2501C18.3333 19.4932 18.2368 19.7264 18.0649 19.8983C17.8929 20.0702 17.6598 20.1667 17.4167 20.1667C17.1736 20.1667 16.9404 20.0702 16.7685 19.8983C16.5966 19.7264 16.5 19.4932 16.5 19.2501V18.3334H17.4167C17.7245 18.3337 18.0316 18.303 18.3333 18.2417V19.2501ZM20.1667 13.7501C20.1667 14.4794 19.8769 15.1789 19.3612 15.6946C18.8455 16.2104 18.146 16.5001 17.4167 16.5001H4.58334C3.85399 16.5001 3.15452 16.2104 2.63879 15.6946C2.12307 15.1789 1.83334 14.4794 1.83334 13.7501V12.8334C1.83707 12.5247 1.87426 12.2174 1.94425 11.9167H3.66667V12.8334C3.66667 13.0765 3.76325 13.3097 3.93516 13.4816C4.10707 13.6535 4.34022 13.7501 4.58334 13.7501C4.82645 13.7501 5.05961 13.6535 5.23152 13.4816C5.40343 13.3097 5.50001 13.0765 5.50001 12.8334V11.9167H16.5V12.8334C16.5 13.0765 16.5966 13.3097 16.7685 13.4816C16.9404 13.6535 17.1736 13.7501 17.4167 13.7501C17.6598 13.7501 17.8929 13.6535 18.0649 13.4816C18.2368 13.3097 18.3333 13.0765 18.3333 12.8334V11.9167H20.0558C20.1258 12.2174 20.163 12.5247 20.1667 12.8334V13.7501Z"
        fill="#18AFAD"
      />
    </g>
    <defs>
      <clipPath id="clip0_1080_1042">
        <rect width={22} height={22} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PhoneIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
  </svg>
);

const TrophyIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1080_1026)">
      <path
        d="M5.49998 8.25008H4.12498C3.51719 8.25008 2.9343 8.00864 2.50453 7.57887C2.07476 7.1491 1.83331 6.5662 1.83331 5.95841C1.83331 5.35063 2.07476 4.76773 2.50453 4.33796C2.9343 3.90819 3.51719 3.66675 4.12498 3.66675H5.49998"
        stroke="#D97706"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 8.25008H17.875C18.4828 8.25008 19.0657 8.00864 19.4955 7.57887C19.9252 7.1491 20.1667 6.5662 20.1667 5.95841C20.1667 5.35063 19.9252 4.76773 19.4955 4.33796C19.0657 3.90819 18.4828 3.66675 17.875 3.66675H16.5"
        stroke="#D97706"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66669 20.1667H18.3334"
        stroke="#D97706"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16669 13.4382V15.5832C9.16669 16.0874 8.73585 16.4816 8.27752 16.6924C7.19585 17.1874 6.41669 18.5532 6.41669 20.1666"
        stroke="#D97706"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8333 13.4382V15.5832C12.8333 16.0874 13.2641 16.4816 13.7225 16.6924C14.8041 17.1874 15.5833 18.5532 15.5833 20.1666"
        stroke="#D97706"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 1.83325H5.5V8.24992C5.5 9.70861 6.07946 11.1076 7.11091 12.139C8.14236 13.1705 9.54131 13.7499 11 13.7499C12.4587 13.7499 13.8576 13.1705 14.8891 12.139C15.9205 11.1076 16.5 9.70861 16.5 8.24992V1.83325Z"
        stroke="#D97706"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1080_1026">
        <rect width={22} height={22} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const DinnerIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 2v10a2 2 0 0 0 2 2h2v8M8 2v8" />
    <path d="M15 2v20M19 2v4a4 4 0 0 1-4 4" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const ArrowRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);


const CatchIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.95831 11C6.81998 7.82833 10.4866 5.5 13.75 5.5C17.0133 5.5 19.305 7.82833 20.1666 11C19.305 14.1808 17.0133 16.5 13.75 16.5C10.4866 16.5 6.81998 14.1808 5.95831 11Z"
      stroke="#2999A3"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 11V11.4583"
      stroke="#2999A3"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6667 16.4359C13.4743 14.8746 12.8283 12.9646 12.8283 11C12.8283 9.03551 13.4743 7.12548 14.6667 5.56421"
      stroke="#2999A3"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.41667 9.78079C6.41667 7.33329 5.115 5.47246 2.5025 5.04163C1.58584 6.41663 1.58584 9.62496 2.71334 11C1.57667 12.375 1.57667 15.5833 2.5025 16.9583C5.115 16.5275 6.41667 14.6666 6.41667 12.2191"
      stroke="#2999A3"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.58831 6.65501C9.34998 5.39001 8.40581 3.88668 7.33331 2.75001H12.65C13.0849 2.7484 13.5063 2.90148 13.8388 3.18191C14.1713 3.46234 14.3932 3.85185 14.465 4.28085L14.6758 5.56418"
      stroke="#2999A3"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6758 16.4359L14.465 17.7192C14.3932 18.1482 14.1713 18.5377 13.8388 18.8181C13.5063 19.0985 13.0849 19.2516 12.65 19.25H8.70831C9.59643 18.2431 10.0826 16.9443 10.0741 15.6017"
      stroke="#2999A3"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const MapIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.9305 5.09028C13.185 5.21744 13.4655 5.28364 13.75 5.28364C14.0345 5.28364 14.315 5.21744 14.5695 5.09028L17.9236 3.41279C18.0634 3.3429 18.2189 3.30994 18.375 3.31706C18.5312 3.32417 18.683 3.37111 18.8159 3.45342C18.9488 3.53573 19.0585 3.65067 19.1345 3.78732C19.2105 3.92396 19.2502 4.07777 19.25 4.23412V15.9345C19.2499 16.1046 19.2024 16.2714 19.1129 16.4162C19.0234 16.5609 18.8953 16.6779 18.7431 16.754L14.5695 18.8412C14.315 18.9684 14.0345 19.0346 13.75 19.0346C13.4655 19.0346 13.185 18.9684 12.9305 18.8412L9.0695 16.9107C8.81504 16.7835 8.53447 16.7173 8.25 16.7173C7.96553 16.7173 7.68497 16.7835 7.4305 16.9107L4.07642 18.5882C3.93649 18.6581 3.781 18.6911 3.62474 18.6839C3.46848 18.6768 3.31665 18.6297 3.18369 18.5473C3.05074 18.4649 2.94109 18.3498 2.86518 18.2131C2.78927 18.0763 2.74962 17.9224 2.75 17.766V6.06653C2.75009 5.89634 2.79756 5.72954 2.88709 5.5848C2.97662 5.44007 3.10468 5.32311 3.25692 5.24703L7.4305 3.15979C7.68497 3.03263 7.96553 2.96643 8.25 2.96643C8.53447 2.96643 8.81504 3.03263 9.0695 3.15979L12.9305 5.09028Z"
      stroke="#0B4784"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 5.28369V19.0337"
      stroke="#0B4784"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 2.96631V16.7163"
      stroke="#0B4784"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const WarningIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9192 16.5L12.5859 3.66671C12.426 3.38456 12.1941 3.14988 11.9139 2.98661C11.6337 2.82333 11.3152 2.7373 10.9909 2.7373C10.6666 2.7373 10.3481 2.82333 10.0679 2.98661C9.78767 3.14988 9.55579 3.38456 9.39589 3.66671L2.06256 16.5C1.90093 16.78 1.81618 17.0976 1.8169 17.4208C1.81761 17.7441 1.90377 18.0614 2.06663 18.3406C2.2295 18.6197 2.46328 18.8509 2.74428 19.0106C3.02528 19.1704 3.34351 19.253 3.66672 19.25H18.3334C18.655 19.2497 18.971 19.1648 19.2494 19.0037C19.5278 18.8427 19.759 18.6112 19.9197 18.3326C20.0804 18.0539 20.1649 17.7379 20.1648 17.4162C20.1648 17.0946 20.0801 16.7786 19.9192 16.5Z"
      stroke="#F43F5E"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 8.25V11.9167"
      stroke="#F43F5E"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 15.5834H11.01"
      stroke="#F43F5E"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BookIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 6.41675V19.2501"
      stroke="#298E6D"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.74998 16.5C2.50686 16.5 2.27371 16.4034 2.1018 16.2315C1.92989 16.0596 1.83331 15.8264 1.83331 15.5833V3.66667C1.83331 3.42355 1.92989 3.19039 2.1018 3.01849C2.27371 2.84658 2.50686 2.75 2.74998 2.75H7.33331C8.30577 2.75 9.2384 3.13631 9.92604 3.82394C10.6137 4.51158 11 5.44421 11 6.41667C11 5.44421 11.3863 4.51158 12.0739 3.82394C12.7616 3.13631 13.6942 2.75 14.6666 2.75H19.25C19.4931 2.75 19.7263 2.84658 19.8982 3.01849C20.0701 3.19039 20.1666 3.42355 20.1666 3.66667V15.5833C20.1666 15.8264 20.0701 16.0596 19.8982 16.2315C19.7263 16.4034 19.4931 16.5 19.25 16.5H13.75C13.0206 16.5 12.3212 16.7897 11.8054 17.3055C11.2897 17.8212 11 18.5207 11 19.25C11 18.5207 10.7102 17.8212 10.1945 17.3055C9.6788 16.7897 8.97933 16.5 8.24998 16.5H2.74998Z"
      stroke="#298E6D"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const RiverIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.41667 14.9417C8.43333 14.9417 10.0833 13.2642 10.0833 11.2292C10.0833 10.1659 9.56083 9.15757 8.51583 8.30507C7.47083 7.45257 6.6825 6.18757 6.41667 4.8584C6.15083 6.18757 5.37167 7.46173 4.3175 8.30507C3.26333 9.1484 2.75 10.1751 2.75 11.2292C2.75 13.2642 4.4 14.9417 6.41667 14.9417Z"
      stroke="#8B5CF6"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5134 6.04998C12.1438 5.04268 12.5907 3.9316 12.8334 2.76831C13.2917 5.05998 14.6667 7.25998 16.5 8.72664C18.3334 10.1933 19.25 11.935 19.25 13.7683C19.2553 15.0354 18.8842 16.2755 18.1837 17.3315C17.4833 18.3874 16.4852 19.2116 15.3158 19.6996C14.1464 20.1876 12.8585 20.3174 11.6153 20.0725C10.372 19.8276 9.22951 19.2191 8.33252 18.3241"
      stroke="#8B5CF6"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const UserIcon = () => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16667 10.0833C11.1917 10.0833 12.8333 8.44171 12.8333 6.41667C12.8333 4.39162 11.1917 2.75 9.16667 2.75C7.14162 2.75 5.5 4.39162 5.5 6.41667C5.5 8.44171 7.14162 10.0833 9.16667 10.0833Z"
      stroke="#64748B"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.44167 13.75H6.41667C5.44421 13.75 4.51158 14.1363 3.82394 14.8239C3.13631 15.5116 2.75 16.4442 2.75 17.4167V19.25"
      stroke="#64748B"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5833 18.3333C17.1021 18.3333 18.3333 17.102 18.3333 15.5833C18.3333 14.0645 17.1021 12.8333 15.5833 12.8333C14.0645 12.8333 12.8333 14.0645 12.8333 15.5833C12.8333 17.102 14.0645 18.3333 15.5833 18.3333Z"
      stroke="#64748B"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.25 19.25L17.5084 17.5083"
      stroke="#64748B"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TitleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </svg>
);

const MessageIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="9" y1="13" x2="15" y2="13" />
    <line x1="9" y1="17" x2="13" y2="17" />
  </svg>
);

const CameraIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

const ParkingIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M9 17V7h5a3 3 0 0 1 0 6H9" />
  </svg>
);

const MapPinIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const VehicleIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4166 15.5834H19.2499C19.7999 15.5834 20.1666 15.2167 20.1666 14.6667V11.9167C20.1666 11.0917 19.5249 10.3584 18.7916 10.1751C17.1416 9.71675 14.6666 9.16675 14.6666 9.16675C14.6666 9.16675 13.4749 7.88341 12.6499 7.05841C12.1916 6.69175 11.6416 6.41675 10.9999 6.41675H4.58325C4.03325 6.41675 3.57492 6.78341 3.29992 7.24175L2.01659 9.90008C1.8952 10.2541 1.83325 10.6258 1.83325 11.0001V14.6667C1.83325 15.2167 2.19992 15.5834 2.74992 15.5834H4.58325"
      stroke="#F59E0B" stroke-width="1.83333"
      stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M6.41659 17.4167C7.42911 17.4167 8.24992 16.5959 8.24992 15.5833C8.24992 14.5708 7.42911 13.75 6.41659 13.75C5.40406 13.75 4.58325 14.5708 4.58325 15.5833C4.58325 16.5959 5.40406 17.4167 6.41659 17.4167Z"
      stroke="#F59E0B" stroke-width="1.83333"
      stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8.25 15.5833H13.75" stroke="#F59E0B"
      stroke-width="1.83333" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M15.5833 17.4167C16.5959 17.4167 17.4167 16.5959 17.4167 15.5833C17.4167 14.5708 16.5959 13.75 15.5833 13.75C14.5708 13.75 13.75 14.5708 13.75 15.5833C13.75 16.5959 14.5708 17.4167 15.5833 17.4167Z"
      stroke="#F59E0B" stroke-width="1.83333"
      stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);
const PoachingIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1237_3069)">
      <path
        d="M10.9999 20.1666C16.0625 20.1666 20.1666 16.0625 20.1666 10.9999C20.1666 5.93731 16.0625 1.83325 10.9999 1.83325C5.93731 1.83325 1.83325 5.93731 1.83325 10.9999C1.83325 16.0625 5.93731 20.1666 10.9999 20.1666Z"
        stroke="#F43F5E" stroke-width="1.83333"
        stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11 7.33325V10.9999" stroke="#F43F5E"
        stroke-width="1.83333" stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M11 14.6667H11.01" stroke="#F43F5E"
        stroke-width="1.83333" stroke-linecap="round"
        stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1237_3069">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const PollutionIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.41667 14.9417C8.43333 14.9417 10.0833 13.2642 10.0833 11.2292C10.0833 10.1659 9.56083 9.15757 8.51583 8.30507C7.47083 7.45257 6.6825 6.18757 6.41667 4.8584C6.15083 6.18757 5.37167 7.46173 4.3175 8.30507C3.26333 9.1484 2.75 10.1751 2.75 11.2292C2.75 13.2642 4.4 14.9417 6.41667 14.9417Z"
      stroke="#8B5CF6" stroke-width="1.83333"
      stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M11.5134 6.04998C12.1438 5.04268 12.5907 3.9316 12.8334 2.76831C13.2917 5.05998 14.6667 7.25998 16.5 8.72664C18.3334 10.1933 19.25 11.935 19.25 13.7683C19.2553 15.0354 18.8842 16.2755 18.1837 17.3315C17.4833 18.3874 16.4852 19.2116 15.3158 19.6996C14.1464 20.1876 12.8585 20.3174 11.6153 20.0725C10.372 19.8276 9.22951 19.2191 8.33252 18.3241"
      stroke="#8B5CF6" stroke-width="1.83333"
      stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

const FlagIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.6665 13.7499C3.6665 13.7499 4.58317 12.8333 7.33317 12.8333C10.0832 12.8333 11.9165 14.6666 14.6665 14.6666C17.4165 14.6666 18.3332 13.7499 18.3332 13.7499V2.74992C18.3332 2.74992 17.4165 3.66659 14.6665 3.66659C11.9165 3.66659 10.0832 1.83325 7.33317 1.83325C4.58317 1.83325 3.6665 2.74992 3.6665 2.74992V13.7499Z"
      stroke="#64748B" stroke-width="1.83333"
      stroke-linecap="round" stroke-linejoin="round" />
    <path d="M3.6665 20.1667V13.75" stroke="#64748B"
      stroke-width="1.83333" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
);


const DropletIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2.5c3 4 6 7.5 6 11a6 6 0 0 1-12 0c0-3.5 3-7 6-11z" />
  </svg>
);

const SunIcon = () => (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#f5b800" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4" fill="#f5b800" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
);
const CloudIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8a8a8a" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
  </svg>
);
const CloudRainIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#3f74e0" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <line x1="16" y1="13" x2="16" y2="21" />
    <line x1="8" y1="13" x2="8" y2="21" />
    <line x1="12" y1="15" x2="12" y2="23" />
    <path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25" />
  </svg>
);
const WindIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.59 4.59A2 2 0 1 1 11 8H2M12.59 19.41A2 2 0 1 0 14 16H2M17.73 7.73A2.5 2.5 0 1 1 19.5 12H2" />
  </svg>
);
const DropletSmall = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2.5c3 4 6 7.5 6 11a6 6 0 0 1-12 0c0-3.5 3-7 6-11z" />
  </svg>
);
const GaugeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 14l4-4" />
    <circle cx="12" cy="14" r="1" fill="#fff" />
    <path d="M3 14a9 9 0 0 1 18 0" />
  </svg>
);

const PdfIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="9" y1="13" x2="15" y2="13" />
    <line x1="9" y1="17" x2="13" y2="17" />
  </svg>
);
const BellIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
)
const BackIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);


const PaperclipIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>
);
const SidebarCatchRetirn = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.41667 10C6.20001 7.11667 9.53334 5 12.5 5C15.4667 5 17.55 7.11667 18.3333 10C17.55 12.8917 15.4667 15 12.5 15C9.53334 15 6.20001 12.8917 5.41667 10Z"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 10V10.4167"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3333 14.9417C12.2493 13.5223 11.6621 11.786 11.6621 10C11.6621 8.21408 12.2493 6.47769 13.3333 5.05835"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83333 8.89171C5.83333 6.66671 4.64999 4.97504 2.27499 4.58337C1.44166 5.83337 1.44166 8.75004 2.46666 10C1.43333 11.25 1.43333 14.1667 2.27499 15.4167C4.64999 15.025 5.83333 13.3334 5.83333 11.1084"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.71667 6.05001C8.50001 4.90001 7.64167 3.53334 6.66667 2.50001H11.5C11.8954 2.49855 12.2785 2.63771 12.5807 2.89265C12.883 3.14759 13.0848 3.50168 13.15 3.89168L13.3417 5.05835"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3417 14.9417L13.15 16.1083C13.0848 16.4983 12.883 16.8524 12.5807 17.1074C12.2785 17.3623 11.8954 17.5015 11.5 17.5H7.91667C8.72405 16.5846 9.16606 15.4039 9.15834 14.1833"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SidebarMapParking = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.755 4.62755C11.9863 4.74315 12.2414 4.80333 12.5 4.80333C12.7586 4.80333 13.0137 4.74315 13.245 4.62755L16.2942 3.10255C16.4213 3.03902 16.5626 3.00906 16.7046 3.01553C16.8466 3.02199 16.9845 3.06467 17.1054 3.1395C17.2262 3.21432 17.3259 3.31882 17.395 3.44304C17.4641 3.56726 17.5002 3.70709 17.5 3.84922V14.4859C17.4999 14.6406 17.4568 14.7922 17.3754 14.9238C17.294 15.0554 17.1776 15.1617 17.0392 15.2309L13.245 17.1284C13.0137 17.244 12.7586 17.3042 12.5 17.3042C12.2414 17.3042 11.9863 17.244 11.755 17.1284L8.245 15.3734C8.01367 15.2578 7.75861 15.1976 7.5 15.1976C7.2414 15.1976 6.98634 15.2578 6.755 15.3734L3.70584 16.8984C3.57863 16.962 3.43727 16.9919 3.29522 16.9854C3.15316 16.9789 3.01513 16.9362 2.89427 16.8612C2.7734 16.7863 2.67372 16.6817 2.60471 16.5574C2.5357 16.433 2.49965 16.2931 2.5 16.1509V5.51505C2.50009 5.36034 2.54324 5.2087 2.62463 5.07712C2.70602 4.94554 2.82244 4.83921 2.96084 4.77005L6.755 2.87255C6.98634 2.75696 7.2414 2.69678 7.5 2.69678C7.75861 2.69678 8.01367 2.75696 8.245 2.87255L11.755 4.62755Z"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 4.80334V17.3033"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 2.69666V15.1967"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SidebarReportIncedent = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1083 15L11.4417 3.33332C11.2963 3.07682 11.0855 2.86347 10.8308 2.71504C10.576 2.56661 10.2865 2.4884 9.99167 2.4884C9.69685 2.4884 9.4073 2.56661 9.15257 2.71504C8.89783 2.86347 8.68703 3.07682 8.54167 3.33332L1.875 15C1.72807 15.2545 1.65103 15.5432 1.65168 15.8371C1.65233 16.1309 1.73065 16.4194 1.87871 16.6732C2.02676 16.927 2.23929 17.1371 2.49475 17.2823C2.7502 17.4275 3.03951 17.5026 3.33334 17.5H16.6667C16.9591 17.4997 17.2463 17.4225 17.4994 17.2761C17.7525 17.1297 17.9627 16.9192 18.1088 16.6659C18.2548 16.4126 18.3317 16.1253 18.3316 15.8329C18.3316 15.5405 18.2545 15.2532 18.1083 15Z"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 7.5V10.8333"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 14.1666H10.01"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SidebarRulesRegulations = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 5.83337V17.5"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.50001 15C2.27899 15 2.06703 14.9122 1.91075 14.7559C1.75447 14.5996 1.66667 14.3877 1.66667 14.1667V3.33333C1.66667 3.11232 1.75447 2.90036 1.91075 2.74408C2.06703 2.5878 2.27899 2.5 2.50001 2.5H6.66667C7.55073 2.5 8.39857 2.85119 9.02369 3.47631C9.64882 4.10143 10 4.94928 10 5.83333C10 4.94928 10.3512 4.10143 10.9763 3.47631C11.6014 2.85119 12.4493 2.5 13.3333 2.5H17.5C17.721 2.5 17.933 2.5878 18.0893 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33333V14.1667C18.3333 14.3877 18.2455 14.5996 18.0893 14.7559C17.933 14.9122 17.721 15 17.5 15H12.5C11.837 15 11.2011 15.2634 10.7322 15.7322C10.2634 16.2011 10 16.837 10 17.5C10 16.837 9.73661 16.2011 9.26777 15.7322C8.79893 15.2634 8.16305 15 7.5 15H2.50001Z"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SidebarCompitition = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1077_800)">
      <path
        d="M5.00001 7.50004H3.75001C3.19747 7.50004 2.66757 7.28055 2.27687 6.88985C1.88617 6.49915 1.66667 5.96924 1.66667 5.41671C1.66667 4.86417 1.88617 4.33427 2.27687 3.94357C2.66757 3.55287 3.19747 3.33337 3.75001 3.33337H5.00001"
        stroke="#9CA3AF"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 7.50004H16.25C16.8025 7.50004 17.3324 7.28055 17.7231 6.88985C18.1138 6.49915 18.3333 5.96924 18.3333 5.41671C18.3333 4.86417 18.1138 4.33427 17.7231 3.94357C17.3324 3.55287 16.8025 3.33337 16.25 3.33337H15"
        stroke="#9CA3AF"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 18.3334H16.6667"
        stroke="#9CA3AF"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33333 12.2167V14.1667C8.33333 14.625 7.94166 14.9833 7.52499 15.175C6.54166 15.625 5.83333 16.8667 5.83333 18.3333"
        stroke="#9CA3AF"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 12.2167V14.1667C11.6667 14.625 12.0583 14.9833 12.475 15.175C13.4583 15.625 14.1667 16.8667 14.1667 18.3333"
        stroke="#9CA3AF"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 1.66663H5V7.49996C5 8.82604 5.52678 10.0978 6.46447 11.0355C7.40215 11.9732 8.67392 12.5 10 12.5C11.3261 12.5 12.5979 11.9732 13.5355 11.0355C14.4732 10.0978 15 8.82604 15 7.49996V1.66663Z"
        stroke="#9CA3AF"
        strokeWidth="1.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1077_800">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const SidebarRiverLavel = () => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83333 13.5833C7.66667 13.5833 9.16667 12.0583 9.16667 10.2083C9.16667 9.24163 8.69167 8.32496 7.74167 7.54996C6.79167 6.77496 6.075 5.62496 5.83333 4.41663C5.59167 5.62496 4.88333 6.78329 3.925 7.54996C2.96667 8.31663 2.5 9.24996 2.5 10.2083C2.5 12.0583 4 13.5833 5.83333 13.5833Z"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4667 5.50006C11.0398 4.58433 11.4461 3.57426 11.6667 2.51672C12.0833 4.60006 13.3333 6.60006 15 7.93339C16.6667 9.26672 17.5 10.8501 17.5 12.5167C17.5048 13.6686 17.1674 14.796 16.5307 15.756C15.8939 16.7159 14.9865 17.4652 13.9234 17.9088C12.8604 18.3524 11.6895 18.4704 10.5593 18.2478C9.4291 18.0252 8.39044 17.472 7.575 16.6584"
      stroke="#9CA3AF"
      strokeWidth="1.83333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SidebarVehicles = () => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1077_812)">
      <path
        d="M15.675 3.21825C15.4108 2.49541 14.9311 1.8711 14.3007 1.42968C13.6703 0.988254 12.9196 0.751008 12.15 0.75H5.85001C5.08041 0.751008 4.32968 0.988254 3.69927 1.42968C3.06886 1.8711 2.58916 2.49541 2.325 3.21825L0.300004 8.7885C0.100841 9.33711 -0.000693549 9.91636 3.5654e-06 10.5V11.25C0.00134181 11.8296 0.137578 12.4009 0.397927 12.9188C0.658277 13.4366 1.03559 13.8867 1.5 14.2335C1.5 14.2395 1.5 14.244 1.5 14.25V15.75C1.5 16.3467 1.73706 16.919 2.15901 17.341C2.58097 17.7629 3.15327 18 3.75 18C4.34674 18 4.91904 17.7629 5.34099 17.341C5.76295 16.919 6.00001 16.3467 6.00001 15.75V15H12V15.75C12 16.3467 12.2371 16.919 12.659 17.341C13.081 17.7629 13.6533 18 14.25 18C14.8467 18 15.419 17.7629 15.841 17.341C16.263 16.919 16.5 16.3467 16.5 15.75V14.25C16.5 14.244 16.5 14.2395 16.5 14.2335C16.9644 13.8867 17.3417 13.4366 17.6021 12.9188C17.8624 12.4009 17.9987 11.8296 18 11.25V10.5C18.0008 9.9166 17.8992 9.33758 17.7 8.78925L15.675 3.21825ZM3.7365 3.73125C3.89508 3.29788 4.18271 2.92353 4.56061 2.65868C4.93851 2.39383 5.38853 2.25119 5.85001 2.25H12.15C12.6117 2.25088 13.0621 2.39338 13.4403 2.65825C13.8185 2.92313 14.1063 3.29764 14.265 3.73125L15.906 8.25H2.09325L3.7365 3.73125ZM4.5 15.75C4.5 15.9489 4.42099 16.1397 4.28033 16.2803C4.13968 16.421 3.94892 16.5 3.75 16.5C3.55109 16.5 3.36033 16.421 3.21967 16.2803C3.07902 16.1397 3 15.9489 3 15.75V14.925C3.24685 14.9751 3.49812 15.0003 3.75 15H4.5V15.75ZM15 15.75C15 15.9489 14.921 16.1397 14.7803 16.2803C14.6397 16.421 14.4489 16.5 14.25 16.5C14.0511 16.5 13.8603 16.421 13.7197 16.2803C13.579 16.1397 13.5 15.9489 13.5 15.75V15H14.25C14.5019 15.0003 14.7532 14.9751 15 14.925V15.75ZM16.5 11.25C16.5 11.8467 16.263 12.419 15.841 12.841C15.419 13.2629 14.8467 13.5 14.25 13.5H3.75C3.15327 13.5 2.58097 13.2629 2.15901 12.841C1.73706 12.419 1.5 11.8467 1.5 11.25V10.5C1.50306 10.2475 1.53349 9.99599 1.59075 9.75H3V10.5C3 10.6989 3.07902 10.8897 3.21967 11.0303C3.36033 11.171 3.55109 11.25 3.75 11.25C3.94892 11.25 4.13968 11.171 4.28033 11.0303C4.42099 10.8897 4.5 10.6989 4.5 10.5V9.75H13.5V10.5C13.5 10.6989 13.579 10.8897 13.7197 11.0303C13.8603 11.171 14.0511 11.25 14.25 11.25C14.4489 11.25 14.6397 11.171 14.7803 11.0303C14.921 10.8897 15 10.6989 15 10.5V9.75H16.4093C16.4666 9.99598 16.497 10.2475 16.5 10.5V11.25Z"
        fill="#9CA3AF"
      />
    </g>
    <defs>
      <clipPath id="clip0_1077_812">
        <rect width={18} height={18} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const SidebarMember = () => (
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.91667 8.70833C9.66557 8.70833 11.0833 7.29057 11.0833 5.54167C11.0833 3.79276 9.66557 2.375 7.91667 2.375C6.16776 2.375 4.75 3.79276 4.75 5.54167C4.75 7.29057 6.16776 8.70833 7.91667 8.70833Z"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.15417 11.875H5.54167C4.70181 11.875 3.89636 12.2086 3.30249 12.8025C2.70863 13.3964 2.375 14.2018 2.375 15.0417V16.625"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4583 15.8333C14.77 15.8333 15.8333 14.7699 15.8333 13.4583C15.8333 12.1466 14.77 11.0833 13.4583 11.0833C12.1467 11.0833 11.0833 12.1466 11.0833 13.4583C11.0833 14.7699 12.1467 15.8333 13.4583 15.8333Z"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.625 16.625L15.1208 15.1208"
      stroke="#9CA3AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const FolderIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#a6234c"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ marginRight: 8, flexShrink: 0 }}
  >
    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
  </svg>
);

const FileIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#a6234c"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ marginRight: 8, flexShrink: 0 }}
  >
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-5-5z" />
    <path d="M14 3v5h5" />
  </svg>
);

export {
  PaperclipIcon,
  SidebarReportIncedent,
  SidebarRulesRegulations,
  BackIcon,
  FileIcon,
  SidebarCompitition,
  SidebarMapParking,
  SidebarCatchRetirn,
  BellIcon,
  SidebarVehicles,
  PdfIcon,
  GaugeIcon,
  FolderIcon,
  DropletSmall,
  WindIcon,
  CloudRainIcon,
  CloudIcon,
  SunIcon,
  SidebarRiverLavel,
  DropletIcon,
  FlagIcon,
  PollutionIcon,
  PoachingIcon,
  VehicleIcon,
  MapPinIcon,
  SidebarMember,
  ParkingIcon,
  TitleIcon,
  MessageIcon,
  CameraIcon,
  CatchIcon,
  MapIcon,
  WarningIcon,
  BookIcon,
  RiverIcon,
  UserIcon,
  TrophyIcon,
  DinnerIcon,
  CalendarIcon,
  ArrowRight,
  PhoneIcon,
  CarIcon,
  SearchIcon,
  VisibilityOffIcon,
  VisibilityIcon,
  HelpOutlineIcon,
  CloseIcon,
  IconLock,
  IconUnlock,
  IconTrash,
  IconDots,
  IconUserPlaceholder,
  IconEmpty,
  IconReset,
  IconEdit,
  HonoraryMemberIcon,
  UnLockedMemberIcon,
  LockedMemberIcon,
  CurrentMemberIcon,
  NewEnquiryIcon,
  EnquiryIcon,
  MemberIcon,
  Eyeopen,
  Eyeclose,
  Dashboardsvg,
  Userssvg,
  Archivesvg,
  Enquirysvg,
  Templatesvg,
  Adminsvg,
  Watersvg,
  Catchsvg,
  Rulessvg,
  Trophy,
  Newslettersvg,
  QuickMessagesvg,
  Fishsvg,
  Mapsvg,
  Incidentsvg,
  Vehiclesvg,
  ZeroIcon,
  FishsvgGreen
};
